import { render } from "./MResetPasswords.vue?vue&type=template&id=198aaf34&scoped=true"
import script from "./MResetPasswords.vue?vue&type=script&lang=js"
export * from "./MResetPasswords.vue?vue&type=script&lang=js"

import "./MResetPasswords.vue?vue&type=style&index=0&id=198aaf34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198aaf34"]])

export default __exports__